import React, { useContext } from "react";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import { normalizeLabel, isPriceOptionSelected, getOptionsWithSelectedOnTop } from "@/helpers/plpHelper";
import { HiddenFiltersContext } from "./HiddenFiltersContext";
import { generalConstants } from "@/utils/constants/general";

const CheckboxList = React.memo(function CheckboxList({
  options,
  selected,
  facetKey,
  onChange,
  getLabel,
  getColor,
  styleClass = "",
  showSearch, 
  onSearch,
  searchValue,
  searchPlaceholder,
  showPriceRange,
  priceMin,
  priceMax,
  onPriceInputChange,
  pricePointsDisabled,
  onPriceInputFocus,
  onPriceInputBlur,
}) {
  const {hiddenFilters} = useContext(HiddenFiltersContext);
  // Use helper to get displayOptions
  let displayOptions = getOptionsWithSelectedOnTop(options, selected, showSearch, normalizeLabel);
  return (
    <ul className={`${'filter_item_list'} ${styleClass}`}>
      {/* Price Range Input as a list element */}
      {showPriceRange && (
        <li>
          <div className="price_range_aria" style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}>
            <div className="input-group">
              <label className="xx-small">Min</label>
              <input
                type="number"
                className="input-control small"
                min="0"
                autoComplete="min"
                aria-label="min-value"
                value={priceMin}
                onChange={e => onPriceInputChange("min", e.target.value)}
                onFocus={onPriceInputFocus}
                onBlur={onPriceInputBlur}
                placeholder="Min"
              />
            </div>
            <div className="input-group">
              <label className="xx-small">Max</label>
              <input
                type="number"
                className="input-control small"
                min="0"
                autoComplete="max"
                aria-label="max-value"
                value={priceMax}
                onChange={e => onPriceInputChange("max", e.target.value)}
                onFocus={onPriceInputFocus}
                onBlur={onPriceInputBlur}
                placeholder="Max"
              />
            </div>
          </div>
        </li>
      )}
      {/* Search box for any filter */}
      {showSearch && (
        <li>
          <div className="inner_searchbar">
            <input
              className="input-control small"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              placeholder={searchPlaceholder || "Search..."}
              spellCheck={false}
              maxLength={512}
              type="search"
              value={searchValue || ""}
              onChange={e => onSearch && onSearch(e.target.value)}
            />
          </div>
        </li>
      )}
      {/* Show 'No results.' if searching and no options match */}
      {showSearch && searchValue && options.length === 0 && (
        <li>
          <div className="">No results.</div>
        </li>
      )}
      {displayOptions.map(option => {
        const isPricePoint = facetKey === generalConstants.FILTER_KEYS.PRICE;
        let checked = false;
        if (isPricePoint) {
          checked = isPriceOptionSelected(selected, option);
        } else {
          checked = Array.isArray(selected)
            ? selected.some(selectedKey =>
                normalizeLabel(selectedKey) === normalizeLabel(option.key)
              )
            : false;
        }
        const color = getColor ? getColor(option) : null;
        // Disable checkbox if this option is in hiddenFilters for this facetKey
        const isHidden =
          hiddenFilters &&
          hiddenFilters[facetKey] &&
          (isPricePoint
            ? hiddenFilters[facetKey].includes(option.key)
            : hiddenFilters[facetKey].some(
                v => normalizeLabel(v) === normalizeLabel(option.key)
              ));
        // Disable for price points if needed
        const disabled = isHidden || (isPricePoint && pricePointsDisabled);

        return (
          <li key={option.key}>
            <div className="custom-checkbox">
              <input
                type="checkbox"
                checked={checked}
                disabled={disabled} // Disable checkbox if filter is from url, eg women/clothing/dresses
                onChange={e => onChange(facetKey, option.key, e.target.checked)}
                id={`${facetKey}-${option.key}`}
              />
              <label htmlFor={`${facetKey}-${option.key}`}>
                {color && (
                  <div className='color-label-outter'>
                    <span
                      className={styles.color_label_inner}
                      style={{ backgroundColor: color }}
                    ></span>
                  </div>
                )}
                <span className="filter-label">{getLabel(option)}</span>
              </label>
            </div>
          </li>
        );
      })}
    </ul>
  );
});

export default CheckboxList;